import PropTypes from 'prop-types';
import {Subtitle} from '../styles';
import {HrLine} from 'ui';
import {
  RecetteSteps,
  Step,
  StepNumber,
  StepDescription,
  Steps,
  RecipeImages,
  RecipeImage,
  Images,
  RecipeImageWrapper,
  ImageNumber,
} from './styles';

const RecipeBlock = ({recipeImages, recipeSteps}) => (
  <RecetteSteps>
    <Subtitle>La Recette</Subtitle>
    <HrLine />
    <Steps>
      {recipeSteps.map((step, id) => (
        // eslint-disable-next-line react/no-array-index-key
        <Step key={id}>
          <StepNumber>{id + 1}</StepNumber>
          <StepDescription>{step.recette_corps_texte}</StepDescription>
        </Step>
      ))}
    </Steps>

    {recipeImages && (
      <RecipeImages>
        <Subtitle>Pour le dressage</Subtitle>
        <HrLine />
        <Images>
          {recipeImages.map((image, id) => (
            // {`${id + 1}-${image.recette_image.url}`}
            // eslint-disable-next-line react/no-array-index-key
            <RecipeImageWrapper key={id}>
              <RecipeImage src={image.recette_image.url} />
              <ImageNumber>{id + 1}</ImageNumber>
            </RecipeImageWrapper>
          ))}
        </Images>
      </RecipeImages>
    )}
  </RecetteSteps>
);

RecipeBlock.propTypes = {
  recipeSteps: PropTypes.array,
  recipeImages: PropTypes.any,
};

export default RecipeBlock;
